import { request } from "@/utils/request"

export function getPageTemplateList(params) {
  return request({
    url: '/appeditor/pagetemplate/list',
    method: 'get',
    params
  })
}

export function savePageTemplate(data) {
  return request({
    url: '/appeditor/pagetemplate/save',
    method: 'post',
    data
  })
}

export function removePageTemplate(ids) {
  return request({
    url: '/appeditor/pagetemplate/remove',
    method: 'post',
    data: ids
  })
}